import {Button, Card, CardContent, CardHeader, Divider, Theme, Typography} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import GetAppIcon from '@material-ui/icons/GetApp';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import {useSnackbar} from 'notistack';
import React, {useState} from 'react';
import useReactRouter from 'use-react-router';
import {Can} from '../../../components/Can';
import ConfirmDelete from '../../../components/ConfirmDelete';
import {LoadingOverlay} from '../../../components/LoadingOverlay';
import {User} from '../../../graphql/auth';
import anyLoading from '../../../utils/anyLoading';
import deleteUser from './deleteUser.api';
import disableUser from './disableUser.api';

const useStyles = makeStyles((theme: Theme) => ({
    root: {},
    mainActions: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
    },
    notice: {
        marginTop: theme.spacing(1)
    },
    deleteButton: {
        marginTop: theme.spacing(1),
        color: theme.palette.white,
        backgroundColor: theme.palette.error.main,
        '&:hover': {
            backgroundColor: theme.palette.error.dark
        }
    },
    buttonIcon: {
        marginRight: theme.spacing(1)
    }
}));

const OtherActions = (props: { user: User, className?: string }) => {
    const {history} = useReactRouter();
    const {className, user, ...rest} = props;
    const [sendDisableUser, disableUserData] = disableUser();
    const [openDelete, setOpenDelete] = useState(false);
    const [sendDelete, deleteData] = deleteUser();
    const loadingData = anyLoading(disableUserData, deleteData);
    const classes = useStyles();
    const {enqueueSnackbar} = useSnackbar();

    const handleDeleteOpen = () => {
        setOpenDelete(true);
    };

    const handleDeleteClose = () => {
        setOpenDelete(false);
    };

    const onDeleteClick = () => {
        sendDelete({variables: {id: user.id}})
            .then(() => {
                enqueueSnackbar('User deleted', {variant: 'success'});
                history.push('/users');
            })
            .catch(() => {
                enqueueSnackbar('Delete failed', {variant: 'error'});
            });
    };

    const onDisableUser = () => {
        sendDisableUser(
            {variables: {data: {id: user.id, disabled: !user.disabled}}}
        )
            .then(() => {
                enqueueSnackbar('User Disabled', {variant: 'success'});
            })
            .catch(() => {
                enqueueSnackbar('Disable failed', {variant: 'error'});
            });
    };

    return (
        <Card {...rest} className={clsx(classes.root, className)}>
            <LoadingOverlay loading={loadingData.loading}>
                <CardHeader title="Other actions"/>
                <Divider/>
                <CardContent>
                    <div className={classes.mainActions}>
                        <Can permission="user.delete">
                            <Button onClick={onDisableUser}>
                                <NotInterestedIcon className={classes.buttonIcon}/>
                                {user.disabled ? 'Enable' : 'Disable'} User Account
                            </Button>
                        </Can>
            
                    </div>

                    <Can permission="user.delete">
                        <Typography className={classes.notice} variant="body2">
                            Remove this users data if requested. Please be aware this action cannot be undone.
                        </Typography>
                        <Button className={classes.deleteButton} onClick={handleDeleteOpen}>
                            <DeleteIcon className={classes.buttonIcon}/>
                            Delete User Account
                        </Button>
                    </Can>
                </CardContent>
            </LoadingOverlay>

            <ConfirmDelete onClose={handleDeleteClose} onDeleteClick={onDeleteClick} open={openDelete}/>
        </Card>
    );
};

export default OtherActions;
